import type { CommandHandler } from '../types';

const resolveInvoicePdfTemplateId = (
  command: Parameters<CommandHandler>[0]
): string | undefined => {
  const fromTemplateSelection = command.templateSelection?.trim();
  if (fromTemplateSelection) {
    return fromTemplateSelection;
  }

  const fromSettings = command.settings?.trim();
  return fromSettings || undefined;
};

export const sendInvoiceToClientCommandHandler: CommandHandler = async (command, context) => {
  const invoiceId = Number(context.entityId ?? context.parentId);
  if (!Number.isInteger(invoiceId) || invoiceId <= 0) {
    return {
      success: false,
      error: 'Invoice ID is not available.',
    };
  }

  if (!context.openSendInvoiceToClientDialog) {
    return {
      success: false,
      error: 'Send invoice dialog is not available.',
    };
  }

  const templateId = resolveInvoicePdfTemplateId(command);
  return context.openSendInvoiceToClientDialog(invoiceId, templateId);
};
